module.exports = __webpack_public_path__ + "static/media/sao-manuel.13dc64ef.jpg";